<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.CREATE') }} {{ $t('SUBSCRIPTIONS.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>

      <v-form ref="form" v-model="valid" lazy-validation>
        <subscription-create-form
          v-model="subscription"
          :person-id="personId"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { onceRequest } from '@/modules/_global/utils/common';
import errors from '@/modules/_global/mixins/errors';
import SubscriptionCreateForm from '../../../subscriptions/components/forms/SubscriptionCreateForm';
import { dateFormatBackend } from '@/modules/_global/filters';

export default {
  name: 'CreateSubscription',

  components: {
    Errors: () => import('@/modules/_global/_components/Errors'),
    SubscriptionCreateForm
  },

  mixins: [errors],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      subscription: {
        from: dateFormatBackend(new Date())
      },
      services: []
    };
  },

  computed: {
    errorsWithoutForm() {
      return ['notruf_subscription']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),
    ...mapActions('person', ['storeSubscription']),

    cancel() {
      this.$emit('cancel');
    },

    create: onceRequest(function create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      return this.storeSubscription({
        personId: this.personId,
        subscription: this.subscription
      })
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });

          this.$emit('created', data.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    })
  }
};
</script>
